"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _AccordionPanel = _interopRequireDefault(require("../AccordionPanel/AccordionPanel"));

var Accordion = function Accordion(_ref) {
  var list = _ref.list,
      defaultActiveKey = _ref.defaultActiveKey,
      className = _ref.className,
      children = _ref.children;

  var _useState = (0, _react.useState)(defaultActiveKey),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1];

  var childrenArray = _react["default"].Children.toArray(children);

  var onClickItem = (0, _react.useCallback)(function (panelKey) {
    var key = panelKey !== activeKey ? panelKey : null;
    setActiveKey(key);
  }, [activeKey]); // Loop through list data

  if (list.length) {
    return list.map(function (_ref2) {
      var key = _ref2.key,
          content = _ref2.content,
          title = _ref2.title;
      return (0, _jsxRuntime.jsx)(_AccordionPanel["default"], {
        panelKey: key,
        onClickItem: onClickItem,
        active: activeKey === key,
        title: title,
        className: className,
        isDefault: defaultActiveKey === key,
        children: content
      }, key);
    });
  } // Or loop through AccordionPanel


  return childrenArray.map(function (child) {
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      onClickItem: onClickItem,
      className: (0, _clsx["default"])(child.props.className, className),
      active: activeKey === child.props.panelKey,
      isDefault: defaultActiveKey === child.props.panelKey
    });
  });
};

Accordion.propTypes = {
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string,
    title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
    content: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
  })),
  defaultActiveKey: _propTypes.string,

  /**
   * For Accordion panel
   */
  className: _propTypes.string,
  children: _propTypes.node
};
Accordion.defaultProps = {
  list: [],
  defaultActiveKey: undefined,
  className: undefined
};
Accordion.Panel = _AccordionPanel["default"];
var _default = Accordion;
exports["default"] = _default;
//# sourceMappingURL=Accordion.js.map